import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useUnitJourneyContext } from "@/hooks/useUnitJourneyContext";
import { useFacility } from "@/hooks/useFacility";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { translateWithMultipleSources } from "@/lib/translate";
import { FunnelType } from "@/lib/utils";
import { emitUnitEvent } from "@/utils/units/unitEvents";

export const useRentalAction = (unitId: number) => {
    const { rentalApp, language } = useDisplayOptionContext();
    const { setIsOpen, setUnitJourneyStep, setSelectedUnitId, setFunnelType } =
        useUnitJourneyContext();
    const { unitGroup, selectedPromo } = useUnitItemContext();

    const facilityId = unitGroup.representative_unit.facility_id;

    const { facility } = useFacility(facilityId);

    const openVbp = () => {
        setSelectedUnitId(unitId);
        setUnitJourneyStep("vbp");
        setIsOpen(true);
    };

    const redirectToExternalRental = () => {
        if (rentalApp?.externalUrl && facility) {
            // Build the rental url.
            const url = translateWithMultipleSources(
                rentalApp.externalUrl || "",
                {
                    unitGroup,
                    facility,
                    promo: { id: selectedPromo },
                },
                unitId,
                selectedPromo,
            );

            // Redirect to the rental url.
            window.location.assign(url);
        } else {
            // Sussy.
            console.error(
                "External rental URL or facility information is missing.",
            );
        }
    };

    const openSamePageRentalFunnel = () => {
        emitUnitEvent(unitId, facilityId, selectedPromo, "rental");
        setUnitJourneyStep("funnel");
        setFunnelType(FunnelType.RENT);
        setIsOpen(true);
    };

    const openRentalFunnel = () => {
        if (rentalApp?.location === "external") {
            redirectToExternalRental();
        } else {
            openSamePageRentalFunnel();
        }
    };

    const label = language?.action?.rentButton || "Rent";

    return { openRentalFunnel, openVbp, label };
};
